import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "../vuex/store";

import AdminClients from "./../components/admin/clients/AdminClients.vue";
import AdminUsers from "./../components/admin/users/AdminUsers.vue";
import AdminIncomeDeclarations from "./../components/admin/incomedeclarations/AdminIncomeDeclarations.vue";
import AdminInvoices from "./../components/admin/invoices/AdminInvoices.vue";
import YearData from "./../components/admin/yeardata/YearData.vue";
import Layout from "./../components/Layout.vue";
import Login from "./../components/auth/Login";
import NoPermission from "./../components/auth/NoPermission";
import VerifyEmail from "./../components/auth/VerifyEmail";
import AskReset from "./../components/auth/AskReset";
import ResetPassword from "./../components/auth/ResetPassword";
import ChangePassword from "./../components/auth/ChangePassword.vue";
import Dashboard from "./../components/Dashboard.vue";
import IncomeDeclarations from "./../components/incomedeclarations/IncomeDeclarations.vue";
import Invoices from "./../components/invoices/Invoices.vue";
import SystemMessagesList from "./../components/systemmessages/SystemMessagesList.vue";
import Tenant from "./../components/tenant/Tenant.vue";
import Options from "./../components/tenant/Options.vue";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		store.commit("getAccessFromCookie");
	}
	if (!store.getters.isAuthenticated) {
		next();
		return;
	} else {
		next("/dashboard");
	}
};

const ifAuthenticated = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		store.commit("getAccessFromCookie");
	}
	if (store.getters.isAuthenticated) {
		next();
		return;
	} else {
		next("/");
	}
};

const ifHasRole = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		store.commit("getAccessFromCookie");
	}
	if (store.getters.isAuthenticated) {
		if (store.getters.getUserRole == null) {
			store.dispatch("fetchUser").then((res) => {
				if (store.getters.getUserRole.includes(to.meta.role)) {
					next();
					return;
				} else {
					next("/nopermission");
				}
			});
		} else {
			if (store.getters.getUserRole.includes(to.meta.role)) {
				next();
				return;
			} else {
				next("/nopermission");
			}
		}
	} else {
		next("/login");
	}
};

const routes = [
	{
		path: "/",
		name: "login",
		component: Login,
		beforeEnter: ifNotAuthenticated,
	},
	{
		path: "/login",
		name: "secondlogin",
		component: Login,
		beforeEnter: ifNotAuthenticated,
	},
	{
		path: "/password/askreset/",
		name: "askreset",
		component: AskReset,
		beforeEnter: ifNotAuthenticated,
	},
	{
		path: "/reset-password-go/",
		name: "resetpassword",
		component: ResetPassword,
		beforeEnter: ifNotAuthenticated,
		props: (route) => ({
			token: route.params.token,
			email: route.params.email,
		}),
	},
	{
		path: "/email/verify/:id/:hash",
		name: "activate",
		component: VerifyEmail,
		props: (route) => ({
			id: route.params.id,
			hash: route.params.token,
		}),
	},
	{
		path: "/",
		name: "layout",
		component: Layout,
		beforeEnter: ifAuthenticated,
		children: [
			{
				path: "/nopermission",
				name: "NoPermission",
				component: NoPermission,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/dashboard",
				name: "dashboard",
				component: Dashboard,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/invoices",
				name: "invoices",
				component: Invoices,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/incomedeclarations",
				name: "incomedeclarations",
				component: IncomeDeclarations,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/system-messages",
				name: "system-messages",
				component: SystemMessagesList,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/options",
				name: "options",
				component: Options,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/tenant",
				name: "tenant",
				component: Tenant,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/changepassword",
				name: "changepassword",
				component: ChangePassword,
				beforeEnter: ifAuthenticated,
			},
			{
				path: "/admin/clients",
				name: "adminclients",
				component: AdminClients,
				beforeEnter: ifHasRole,
				meta: { role: "admin" },
			},
			{
				path: "/admin/users",
				name: "adminusers",
				component: AdminUsers,
				beforeEnter: ifHasRole,
				meta: { role: "admin" },
			},
			{
				path: "/admin/invoices",
				name: "admininvoices",
				component: AdminInvoices,
				beforeEnter: ifHasRole,
				meta: { role: "admin" },
			},
			{
				path: "/admin/incomedeclarations",
				name: "adminincomedeclarations",
				component: AdminIncomeDeclarations,
				beforeEnter: ifHasRole,
				meta: { role: "admin" },
			},
			{
				path: "/admin/yeardata",
				name: "yeardata",
				component: YearData,
				beforeEnter: ifHasRole,
				meta: { role: "admin" },
			},
		],
	},
];

export const router = new VueRouter({
	mode: "history",
	base: process.env.MIX_BASE_PATH,
	routes,
	scrollBehavior() {
		document.getElementById("app").scrollIntoView();
	},
});

window.popStateDetected = false;
window.addEventListener("popstate", () => {
	window.popStateDetected = true;
});

router.beforeEach((to, from, next) => {
	const IsItABackButton = window.popStateDetected;
	window.popStateDetected = false;
	if (!store.getters.isOffline) {
		if (!to.matched.length) {
			next("/");
		} else {
			if (store.getters.hasPopupOpen) {
				let hidevalue = store.getters.getPopupOpened[0];
				if (hidevalue) {
					hidevalue = hidevalue.replace("show", "hide");
					store.dispatch("hideAction", hidevalue);
					if (IsItABackButton) {
						next(false);
						return;
					}
				}
			}
			store.commit("setTimeout", null);
			if (to.name) {
				store.commit("setCurrentRoute", to.name);
			}
			next();
		}
	}
});
